import { Typography } from "@mui/material";
import { useState } from "react";
import React from "react";
import HomeIcono from "../../components/HomeIcon/HomeIcono";
import styles from "./Register.module.css";
import { usuariosLogic, User } from "../../../Logic/Usuarios";
import MailAuth from "../../components/auth/MailAuth";
import { useNavigate } from "react-router-dom";

const Register: React.FC = () => {
      const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [email, setMail] = useState("");
  const [checkAvisoPrivacidad, setCheckAvisoPrivacidad] = useState(false)
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [yaRegistrado, setYaRegistrado] = useState(false);
  const [usuario, setUsuario] = useState<{ nombre: string; email: string } | null>(null);
  const [identificar, setIdentificar] = useState(false);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@(mpao\.mx|tres17\.com|gmail\.com|icloud\.com|live\.com|hotmail\.com)$/;
    

  React.useEffect(() => {
    const data = localStorage.getItem("usuarioRegistrado");
  if (data) {
    const usuarioRegistrado = JSON.parse(data);
    setUsuario(usuarioRegistrado);
    setYaRegistrado(true);
  }
  }, [yaRegistrado]);

  const handleChangeMail = (e: any) => {
    if (emailRegex.test(e.target.value) || e.target.value == "") setError("");
    else setError("Correo Inválido.");

    setMail(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (error !== "") return;

    setMensaje("");
    setError("");
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("Nombre", nombre.trim());
      formData.append("Apellido", apellido.trim());
      formData.append("Email", email.trim());

      await usuariosLogic.RegisterUser(formData).then((response) => {
      
        if (!response) throw new Error("Error al registrar.");
        
          // Guardar datos en localStorage
          localStorage.setItem("usuarioRegistrado", JSON.stringify({
            nombre,
            apellido,
            email,
          }));
          
        setMensaje("Registro exitoso");
           setTimeout(() => setYaRegistrado(true), 2000);
           window.location.reload();
      });
    } catch (err) {
      setError("No se pudo completar el registro.");
    } finally {
      setLoading(false);
      setNombre("");
      setApellido("");
      setMail("");
      setCheckAvisoPrivacidad(false);
      setTimeout(() => setMensaje(""), 2000);
    }
  };

  return (
    <>
      <HomeIcono></HomeIcono>
      <Typography
        variant="h2"
        component="h2"
        align="center"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontSize: 40,
          lineHeight: 1.2,
          fontWeight: 900,
          color: "black",
        }}
      >
        ¡SHALOM!
      </Typography>

      <Typography
        variant="h2"
        component="h2"
        align="center"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontSize: 40,
          lineHeight: 1.2,
          fontWeight: 900,
          marginBottom: 5,
          color: "black",
        }}
      >
        NOS ALEGRA DE QUE ESTÉS AQUÍ
      </Typography>

      {yaRegistrado ? (
<div className={styles.userRegistered}>
    Gracias por registrarte, <strong>{usuario?.nombre}</strong>. <br /><br />
    Pronto nos pondremos en contacto contigo a través del correo <strong>{usuario?.email}</strong> proporcionado para las siguientes actualizaciones y/o avisos de la comunidad. <br />
<br />
    Para cualquier duda, puedes comunicarte con nosotros por   <a style={{color:"#008d26", fontWeight:"750"}} target="_blank"
            href="https://wa.me/+522221517369?text=Hola%20tengo%20la%20siguiente%20duda%20:%20....">
            WhatsApp
            </a> o por el correo <strong><a href="mailto:sulamcollective@gmail.com">sulamcollective@gmail.com</a></strong>

  </div>
  ) : (
  <div className={styles.formContainer}>
        <form onSubmit={handleSubmit}>
          <label className={styles.inputLabel}>Nombre</label>
          <input
            className={styles.inputField}
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            required
          />

          <label className={styles.inputLabel}>Apellidos</label>
          <input
            className={styles.inputField}
            value={apellido}
            onChange={(e) => setApellido(e.target.value)}
            required
          />

          <label className={styles.inputLabel}>Correo</label>
          <input
            className={styles.inputField}
            value={email}
            onChange={handleChangeMail}
            required
          />

          <Typography variant="body2" align="center" sx={{ margin: 2 }}>
            <input 
            type="checkbox"
             checked={checkAvisoPrivacidad} 
             required   
             onChange={(e) => setCheckAvisoPrivacidad(e.target.checked)}
             /> 
             He leído y acepto el{" "}
            <a href="/privacidad" target="_blank">
              {" "}
              Aviso de Privacidad
            </a>
          </Typography>

          <button
            type="submit"
            className={styles.submitButton}
            disabled={loading}
          >
            {loading ? "ENVIANDO DATOS.." : "REGISTRARSE"}
          </button>
        </form>

        {mensaje && <div className={styles.successMessage}>{mensaje}</div>}
        {error && <div className={styles.errorMessage}>{error}</div>}
      </div>

)}
{yaRegistrado ? null : 
<>
<br></br>
<hr></hr>
<div className={styles.identificarContainer}>
<Typography
        variant="h2"
        component="h2"
        align="center"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontSize: 40,
          lineHeight: 1.2,
          fontWeight: 900,
          color: "black",
        }}
      >
        ¿Ya te has registrado previamente?
      </Typography>
      <br></br>
        <Typography
        variant="h3"
        component="h3"
        align="center"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontSize: 30,
          lineHeight: 1.2,
          color: "black",
        }}
      >
       
      </Typography>
        <button
        onClick={() => setIdentificar(true)}
            className={styles.identificarBtn}
          >
             IDENTIFÍCATE CON TU CORREO 
          </button>
</div></>
}
<MailAuth isOpen={identificar} onClose={() => setIdentificar(false)} onSuccess={() => {setYaRegistrado(true); setIdentificar(false); navigate("/"); window.location.reload(); }}></MailAuth>
    </>
  );
};

export default Register;
